module.exports = __webpack_public_path__ + "static/radical-3c2c36c1faf510f444875119b6709f2c.jpg";